export default {
  CANCEL_SESSION: 'CANCEL_SESSION',
  RESCHEDULE_SESSION: 'RESCHEDULE_SESSION'
};
